import React, { useState } from 'react'
import { Box, CircularProgress, Alert } from '@mui/material'
import { Section, ReportTable, SubTabs } from '../../report-shell'

const OrangeOpaskaSalonTable = ({ data, loading, error }) => {
  const [subTab, setSubTab] = useState(0)

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) return <Alert severity="error">{error}</Alert>
  if (!data) return null

  const salonColumns = [
    { field: 'name', header: 'Nazwa', width: '1.4fr', minWidth: 180 },
    { field: 'kam', header: 'KAM', width: '100px' },
    { field: 'last_day', header: 'Ostatni dzień', width: '120px', sales: true },
    { field: 'current_month', header: 'Bieżący mies.', width: '125px', sales: true },
    { field: 'prev_month', header: 'Poprzedni mies.', width: '135px', numeric: true },
    { field: 'total', header: 'Total', width: '90px', numeric: true },
    { field: 'city', header: 'Miasto', width: '125px' },
    { field: 'street', header: 'Ulica', width: '140px' },
    { field: 'name2', header: 'Nazwa dod.', width: '140px' },
  ]

  const salonServiceColumns = [
    { field: 'Nazwa', header: 'Nazwa', width: '1.4fr', minWidth: 180 },
    { field: 'z_usluga_last_day', header: 'Z usł. — ost. dzień', width: '160px', sales: true },
    { field: 'bez_uslugi_last_day', header: 'Bez usł. — ost. dzień', width: '170px', sales: true },
    { field: 'z_usluga_current', header: 'Z usł. — bież.', width: '130px', sales: true },
    { field: 'bez_uslugi_current', header: 'Bez usł. — bież.', width: '140px', sales: true },
    { field: 'z_usluga_prev', header: 'Z usł. — poprz.', width: '130px', numeric: true },
    { field: 'bez_uslugi_prev', header: 'Bez usł. — poprz.', width: '140px', numeric: true },
  ]

  const salonRows = (data.by_salon || []).map((r, i) => ({ id: r.name || i, ...r }))
  const salonSvcRows = (data.by_salon_service || []).map((r, i) => ({ id: r.Nazwa || i, ...r }))

  const tabs = [
    { label: 'Sprzedaż per salon',  rows: salonRows,    columns: salonColumns,        sortField: 'total' },
    { label: 'Z usługą / bez usługi', rows: salonSvcRows, columns: salonServiceColumns, sortField: 'z_usluga_current' },
  ]
  const active = tabs[subTab]

  return (
    <Section
      title="Salony"
      right={<SubTabs tabs={tabs.map(t => t.label)} value={subTab} onChange={setSubTab} />}
    >
      <ReportTable
        rows={active.rows}
        columns={active.columns}
        initialSort={{ field: active.sortField, dir: 'desc' }}
        pageSize={25}
        pageSizeOptions={[25, 50, 100]}
        density="compact"
      />
    </Section>
  )
}

export default OrangeOpaskaSalonTable
